function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M21.3103 5.545L11.2073 0.09C10.9843 -0.03 10.7173 -0.03 10.4943 0.09L0.393335 5.545C0.0293351 5.742 -0.106665 6.197 0.0903352 6.562C0.225335 6.812 0.484335 6.955 0.750335 6.955C0.870335 6.955 0.993335 6.925 1.10634 6.865L1.92134 6.425L3.55033 17.938C3.76433 19.153 4.85834 20 6.20833 20H15.4903C16.8423 20 17.9353 19.152 18.1533 17.913L19.7793 6.423L20.5973 6.865C20.9613 7.058 21.4173 6.925 21.6143 6.561C21.8103 6.198 21.6743 5.743 21.3103 5.545ZM16.6723 17.678C16.5653 18.284 15.9693 18.5 15.4923 18.5H6.21034C5.73034 18.5 5.13534 18.284 5.03234 17.702L3.33034 5.665L10.8503 1.603L18.3723 5.663L16.6723 17.678Z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M7.07034 10.159C7.07034 12.243 8.76534 13.939 10.8503 13.939C12.9353 13.939 14.6303 12.243 14.6303 10.159C14.6303 8.075 12.9353 6.379 10.8503 6.379C8.76534 6.379 7.07034 8.075 7.07034 10.159ZM13.1303 10.159C13.1303 11.417 12.1083 12.439 10.8503 12.439C9.59234 12.439 8.57034 11.417 8.57034 10.159C8.57034 8.901 9.59234 7.879 10.8503 7.879C12.1083 7.879 13.1303 8.901 13.1303 10.159Z"
});

var SvgHome = function SvgHome(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHome, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/home.3f77af56.svg";
export { ForwardRef as ReactComponent };